/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import _ from 'lodash';
import React, { useEffect } from 'react';
import { dashboardService } from '../../api/services/dashboardService';
import { bankInfoType } from '../../common/interfaces/myProfile/personalDetails/bankInfoType';
import { emergencyContactType } from '../../common/interfaces/myProfile/personalDetails/emergencyContactType';
import { jobInfoType } from '../../common/interfaces/myProfile/personalDetails/jobInfo';
import { personalInfoType } from '../../common/interfaces/myProfile/personalDetails/personalInfo';
import { getEmergencyDetailReducer } from '../../infra/aggregates/myProfile/emergencyContactSlice';
import { jobInfoReducer } from '../../infra/aggregates/myProfile/jobInfoSlice';
import { personalInfoReducer } from '../../infra/aggregates/myProfile/personalInfoSlice';
import { getAllEmployeeSkills } from '../../infra/aggregates/myProfile/skillsSlice';
import { useAppDispatch, useAppSelector } from '../../infra/hooks';
import AuthInterface from '../../infra/aggregates/AuthInterface';
import { user_login } from '../../infra/aggregates/authSlice';
import { setUserAwards } from '../../infra/aggregates/userAwardsSlice';
import { setEnablecheckin } from '../../infra/aggregates/myProfile/attendancesettingSlice';
import {
  setEditAccess,
  setRoleInfo,
  setViewAccess,
} from '../../infra/aggregates/UserRoleInfo';

interface PropsValue {
  getempProPic: any;
}
function DTODashboard({ getempProPic }: PropsValue) {
  const selector = useAppSelector((state) => state);

  const dispatch = useAppDispatch();

  let personal_Info_data: personalInfoType = {
    firstName: '',
    lastName: '',
    DOB: new Date(),
    gender: '',
    martialStatus: '',
    country: '',
    email: '',
    phone: '',
    countryId: 0,
    genderId: 0,
    maritalStatusId: 0,
    education: '',
    religious: '',
    nationalityId: 0,
    nationalityName: '',
  };

  let job_Info_data: jobInfoType = {
    staffId: 0,
    hireDate: new Date(),
    departmentName: '',
    departmentId: 0,
    employeeType: '',
    contractType: '',
    employeeCategory: '',
    payrollType: '',
    contractTypeId: 0,
    employeeCategoryId: 0,
    employeeTypeId: 0,
    payrollTypeId: 0,
  };

  let emergency_contact_data: emergencyContactType = {
    emergencyContactNumber: 0,
    emergencyPersonName: '',
    emergencyCountry: '',
    emergencyEmail: '',
    emergencyRelationship: '',
  };
  let bank_data: bankInfoType = {
    accountName: '',
    accountNo: 0,
    bankName: '',
    IBAN: '',
    MOL: '',
    UAN: '',
    ifsc: '',
    routing_number: '',
  };

  async function getJobInfo() {
    const employeeId = selector.authSlice.emp_id;
    const response = await dashboardService.getdashboardService(employeeId);
    if (response) {
      const { get_emp_details }: any = response;

      let award = '';

      if (get_emp_details?.awards?.length) {
        award =
          get_emp_details?.awards[get_emp_details?.awards?.length - 1]
            ?.award_type?.name;
      }

      getempProPic(get_emp_details?.user?.profile_pic);
      dispatch(setUserAwards(award));
      const user_obj: AuthInterface = {
        user_id: get_emp_details?.user?.id,
        name: get_emp_details?.first_name,
        username: get_emp_details?.user?.username,
        currency: selector.authSlice.currency,
        email: get_emp_details?.user?.email,
        status: get_emp_details?.status,
        profile_pic: selector.authSlice.profile_pic,
        company_id: get_emp_details.company_id,
        designaion: get_emp_details?.emp_job_detail?.designation?.name,
        department: get_emp_details?.emp_job_detail?.department?.name,
        emp_id: get_emp_details.emp_job_detail?.emp_id,
        department_id: get_emp_details?.emp_job_detail?.department?.id,
        staff_id: get_emp_details?.staff_id,
        hire_date: get_emp_details?.emp_job_detail?.hire_date,
      };

      personal_Info_data = {
        firstName: get_emp_details.first_name,
        lastName: get_emp_details.last_name,
        DOB: get_emp_details.dob,
        gender: get_emp_details?.gender_name?.name,
        genderId: get_emp_details?.gender_name?.id,
        martialStatus: get_emp_details?.marital_status?.name,
        maritalStatusId: get_emp_details?.marital_status?.id,
        country: get_emp_details?.country?.name,
        countryId: get_emp_details?.country?.id,
        email: get_emp_details?.email,
        phone: get_emp_details?.phone,
        education: get_emp_details?.education,
        religious: get_emp_details?.religious,
        nationalityId: get_emp_details?.country_of_birth?.id,
        nationalityName: get_emp_details?.country_of_birth?.name,
      };

      job_Info_data = {
        staffId: get_emp_details?.staff_id,
        hireDate: get_emp_details?.emp_job_detail?.hire_date,
        departmentName: get_emp_details?.emp_job_detail?.department?.name,
        departmentId: get_emp_details?.emp_job_detail?.department?.id,

        employeeType: get_emp_details?.emp_job_detail?.employee_type?.name,
        employeeTypeId: get_emp_details?.emp_job_detail?.employee_type?.id,
        contractType: get_emp_details?.emp_job_detail?.contract_type?.name,
        contractTypeId: get_emp_details?.emp_job_detail?.contract_type?.id,
        employeeCategory:
          get_emp_details?.emp_job_detail?.employee_category?.name,
        employeeCategoryId:
          get_emp_details?.emp_job_detail?.employee_category?.id,
        payrollType: get_emp_details?.emp_job_detail?.payroll_type?.name,
        payrollTypeId: get_emp_details?.emp_job_detail?.payroll_type?.id,
      };

      emergency_contact_data = {
        emergencyContactNumber: get_emp_details?.emergency_contact,
        emergencyPersonName: get_emp_details?.emergency_person,
        emergencyCountry: get_emp_details?.emergency_country,
        emergencyEmail: get_emp_details?.emergency_email,
        emergencyRelationship: get_emp_details?.emergency_relationship,
      };

      bank_data = {
        accountName: get_emp_details?.emp_bank_detail?.account_holder_name,
        accountNo: get_emp_details?.emp_bank_detail?.account_no,
        bankName: get_emp_details?.emp_bank_detail?.bank_name,
        IBAN: get_emp_details?.emp_bank_detail?.ifsc_code,
        MOL: get_emp_details?.emp_bank_detail?.mol,
        UAN: get_emp_details?.emp_bank_detail?.uan,
        ifsc: get_emp_details?.emp_bank_detail?.ifsc,
        routing_number: get_emp_details?.emp_bank_detail?.bank_routing_no,
      };
      dispatch(user_login(user_obj));
      dispatch(jobInfoReducer(job_Info_data));

      dispatch(personalInfoReducer(personal_Info_data));

      dispatch(getEmergencyDetailReducer(emergency_contact_data));
      //dispatch(getBankInfoReducer(bank_data));

      dispatch(getAllEmployeeSkills(get_emp_details?.emp_skills));
    } else {
      return;
    }
  }
  async function getcheckattendanceconfig() {
    const company_id = selector.authSlice.company_id;
    await dashboardService
      .getcheckclockinandoutEnable(company_id)
      .then((response: any) => {
        const isempportal: any = response?.isempportal == 1 ? true : false;
        dispatch(setEnablecheckin(isempportal));
      })
      .catch((err: any) => {
        //console.log("err---", err);
      });
  }
  const userId = useAppSelector((state: any) => state.authSlice.user_id);
  const locale = localStorage.getItem('emplang');

  async function getUserData() {
    dashboardService.getUserInfo(userId, locale).then((res: any) => {
      function checkPermission(res: any, permissionName: any) {
        return _.map(res, function (e) {
          const filter = e.role.role_has_permissions;
          const access = _.filter(filter, function (permissionObj: any) {
            return permissionObj?.permission?.name === permissionName;
          });
          return access;
        });
      }
      const editPermissions = checkPermission(res, 'Employee AD Edit Access');
      const viewPermissions = checkPermission(res, 'Employee AD View Access');
      dispatch(setRoleInfo(res[0].role));
      if (
        editPermissions.some((data) => data.length > 0) ||
        viewPermissions.some((data) => data.length > 0)
      ) {
        dispatch(setViewAccess(true));
      } else {
        dispatch(setViewAccess(false));
      }
      if (editPermissions.some((data) => data.length > 0)) {
        dispatch(setEditAccess(true));
      } else {
        dispatch(setEditAccess(false));
      }
    });
  }
  useEffect(() => {
    getJobInfo();
    getcheckattendanceconfig();
    getUserData();
  }, []);

  return <></>;
}

export default DTODashboard;
